import { CheckCircle, X, Zap } from "lucide-react";

const SolvedProblems = () => {
  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-slate-900 to-slate-800 text-white">
      <div className="max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-4xl sm:text-5xl font-bold mb-6">
              ¿Cansado de perder tiempo en papeles?
            </h2>
            <div className="space-y-4 text-lg text-slate-300">
              <div className="flex items-start gap-3">
                <X className="w-6 h-6 text-red-400 flex-shrink-0 mt-1" />
                <p>Pacientes que no llegan porque se olvidaron</p>
              </div>
              <div className="flex items-start gap-3">
                <X className="w-6 h-6 text-red-400 flex-shrink-0 mt-1" />
                <p>Historiales perdidos o desorganizados</p>
              </div>
              <div className="flex items-start gap-3">
                <X className="w-6 h-6 text-red-400 flex-shrink-0 mt-1" />
                <p>No saber cuánto estás ganando realmente</p>
              </div>
            </div>
          </div>

          <div className="bg-white/10 backdrop-blur-xl rounded-2xl p-8 border border-white/20">
            <h3 className="text-3xl font-bold mb-6 flex items-center gap-3">
              <Zap className="w-8 h-8 text-yellow-400" />
              Con OdontoStark
            </h3>
            <div className="space-y-4 text-lg">
              <div className="flex items-start gap-3">
                <CheckCircle className="w-6 h-6 text-emerald-400 flex-shrink-0 mt-1" />
                <p>Recordatorios automáticos por WhatsApp</p>
              </div>
              <div className="flex items-start gap-3">
                <CheckCircle className="w-6 h-6 text-emerald-400 flex-shrink-0 mt-1" />
                <p>Todo el historial en 2 segundos</p>
              </div>
              <div className="flex items-start gap-3">
                <CheckCircle className="w-6 h-6 text-emerald-400 flex-shrink-0 mt-1" />
                <p>Reportes financieros automáticos</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SolvedProblems;
